import { useDisclosure, Menu, MenuButton, MenuList, Box } from "@chakra-ui/react";
import { AltArrowExpand } from "@airhelp/icons";
import type { MenuExtendedProps } from "config/menus/menus.d";
import { menuButtonStyles } from "./MenuLinkWithSubmenu.styles";
import { SubmenuContent } from "./SubmenuContent";

export const MenuLinkWithSubmenuDesktop = ({
  menulink,
  submenu,
}: {
  submenu: MenuExtendedProps["subMenu"];
  menulink: JSX.Element;
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <Menu isOpen={isOpen}>
      <MenuButton sx={menuButtonStyles} onMouseEnter={onOpen} onMouseLeave={onClose} display="inline-block">
        {menulink}
        <AltArrowExpand
          boxSize={6}
          display={{ base: "none", lg: "inline" }}
          transform={isOpen ? "rotate(180deg)" : "initial"}
          transition="transform 0.2s ease-in-out"
        />
      </MenuButton>
      <MenuList
        shadow="none"
        border="none"
        onMouseEnter={onOpen}
        onMouseLeave={onClose}
        pb={0}
        mt={-2}
        bg="transparent"
      >
        <Box
          mt={4}
          minW="50"
          shadow="md"
          border="1px"
          borderColor="greyscale.400"
          bgColor="white"
          rounded="md"
          textAlign="left"
        >
          <SubmenuContent submenu={submenu} px={6} py={3} mb={0} />
        </Box>
      </MenuList>
    </Menu>
  );
};
